(function () {
  function getStage(deferred) {
    return deferred ? deferred.closest('.custom-video__stage') : null;
  }

  /* Reveal overlay + video in the same tick (no blink) */
  function markReady(deferred) {
    if (!deferred) return;
    var stage = getStage(deferred);

    deferred.setAttribute('data-cv-ready', 'true');
    if (stage) stage.classList.add('custom-video__stage--playing');
  }

  function clearReady(deferred) {
    if (!deferred) return;
    var stage = getStage(deferred);

    deferred.removeAttribute('data-cv-ready');
    if (stage) stage.classList.remove('custom-video__stage--playing');
  }

  function restorePoster(deferred) {
    if (!deferred || !deferred.hasAttribute('loaded')) return;

    deferred.querySelectorAll('video, iframe').forEach(function (media) {
      if (media.tagName === 'VIDEO') {
        media.pause();
      }
      media.remove();
    });

    deferred.removeAttribute('loaded');
    clearReady(deferred);
  }

  function bindHostedVideo(deferred, video) {
    var hasPlayed = false;
    var hasControls = video.hasAttribute('controls');

    video.addEventListener('playing', function () {
      hasPlayed = true;
      markReady(deferred);
    });

    // Pause keeps the current frame. Native controls already handle resume;
    // without controls, click the video to toggle play/pause.
    if (!hasControls) {
      video.addEventListener('click', function () {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });
    }

    video.addEventListener('ended', function () {
      if (hasControls) return;
      restorePoster(deferred);
    });

    // Fallback if playing event is delayed
    setTimeout(function () {
      if (deferred.hasAttribute('loaded') && !deferred.hasAttribute('data-cv-ready') && !video.paused) {
        markReady(deferred);
      }
    }, 800);
  }

  function bindYoutube(deferred, iframe) {
    var hasPlayed = false;

    function onMessage(event) {
      if (!event.origin.includes('youtube.com')) return;

      var data = event.data;
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) {
          return;
        }
      }

      if (!data || data.event !== 'onStateChange') return;

      // 1 = playing, 2 = paused, 0 = ended — pause keeps the current frame
      if (data.info === 1) {
        hasPlayed = true;
        markReady(deferred);
      }

      if (data.info === 0 && hasPlayed) {
        window.removeEventListener('message', onMessage);
        restorePoster(deferred);
      }
    }

    window.addEventListener('message', onMessage);

    iframe.addEventListener('load', function () {
      iframe.contentWindow.postMessage(
        JSON.stringify({ event: 'listening', id: iframe.id || 'custom-video' }),
        '*'
      );
      iframe.contentWindow.postMessage(
        JSON.stringify({
          event: 'command',
          func: 'addEventListener',
          args: ['onStateChange'],
        }),
        '*'
      );
    });

    // Fallback if postMessage state never arrives
    setTimeout(function () {
      if (deferred.hasAttribute('loaded') && !deferred.hasAttribute('data-cv-ready')) {
        markReady(deferred);
      }
    }, 1200);
  }

  function bindVimeo(deferred, iframe) {
    var hasPlayed = false;

    function onMessage(event) {
      if (!event.origin.includes('vimeo.com')) return;

      var data = event.data;
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) {
          return;
        }
      }

      if (!data) return;

      if (data.event === 'play') {
        hasPlayed = true;
        markReady(deferred);
      }

      if (data.event === 'finish' && hasPlayed) {
        window.removeEventListener('message', onMessage);
        restorePoster(deferred);
      }
    }

    window.addEventListener('message', onMessage);

    iframe.addEventListener('load', function () {
      iframe.contentWindow.postMessage({ method: 'addEventListener', value: 'play' }, '*');
      iframe.contentWindow.postMessage({ method: 'addEventListener', value: 'pause' }, '*');
      iframe.contentWindow.postMessage({ method: 'addEventListener', value: 'finish' }, '*');
    });

    setTimeout(function () {
      if (deferred.hasAttribute('loaded') && !deferred.hasAttribute('data-cv-ready')) {
        markReady(deferred);
      }
    }, 1200);
  }

  function bindDeferred(deferred) {
    if (deferred.dataset.cvBound === 'true') return;
    deferred.dataset.cvBound = 'true';

    var observer = new MutationObserver(function () {
      if (!deferred.hasAttribute('loaded')) {
        clearReady(deferred);
        return;
      }

      var video = deferred.querySelector('video');
      var iframe = deferred.querySelector('iframe');

      if (video) {
        bindHostedVideo(deferred, video);
        return;
      }

      if (!iframe) return;

      var type = iframe.dataset.videoType;
      if (type === 'youtube' || iframe.classList.contains('js-youtube')) {
        bindYoutube(deferred, iframe);
      } else if (type === 'vimeo' || iframe.classList.contains('js-vimeo')) {
        bindVimeo(deferred, iframe);
      }
    });

    observer.observe(deferred, { attributes: true, attributeFilter: ['loaded'] });
  }

  function init(root) {
    (root || document)
      .querySelectorAll('deferred-media.custom-video__media')
      .forEach(bindDeferred);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init();
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
